export default [
      {
        image:'https://www.airasia.com/aa/ride/images/driver_phone_image_desktop.png',
        title: 'Mulai berkendara dan menghasilkan sekarang!',
        description: 'Menjadi pengemudi dengan mendaftar di airasia Super App',
        appstoreIMG:'https://www.airasia.com/aa/images/logo/app-store-badge.png',
        appstoreURL:'https://apps.apple.com/my/app/airasia-ride-driver/id1336397298',
        playstoreIMG:'https://www.airasia.com/aa/images/logo/google-play-badge.png',
        playstoreURL:'https://play.google.com/store/apps/details?id=com.dacsee',
      }
  ]
